module.exports = __webpack_public_path__ + "img/Stakingfe.af9e801e.png";